<template>
    <StandardDropdown
        :modelValue="value ? { name: value, key: value } : null"
        :options="genders"
        placeholder="Select Gender"
        class="inter-rule-spacing"
        @change="$emit('handleValueChange', $event.value.key)"
    />
</template>

<script>
import StandardDropdown from '@/components/common/StandardDropdown.vue';
import { Genders } from '@/store/constants';

export default {
    name: 'GenderRule',
    props: ['value'],
    components: { StandardDropdown },
    data() {
        return {
            genders: Genders,
        };
    },
};
</script>

<style scoped></style>
